/*
 * @Author: guoyuehua guoyuehua@58.com
 * @Date: 2023-07-12 16:58:14
 * @LastEditors: yangfei03
 * @LastEditTime: 2024-05-15 18:10:22
 * @FilePath: /credit_loan_pc/views/pages/index/App.js
 * @Description: 首页APP
 */
import React, { Component } from "react";

import "./index.scss";

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			nTime: new Date().getFullYear(),
			wHeight:
				window.innerHeight ||
				document.documentElement.clientHeight ||
				document.body.clientHeight,
			wWidth:
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth,
		};
	}

	render() {
		return (
			<div className="credit-loan-pc flex-cl">
				<div className="has-img-bg-body">
					<span
						className="has-img-bg-body-header-presets"
						style={{
							height: `${this.state.wHeight}px`,
							width: `${this.state.wWidth - 20}px`,
						}}
					/>
					<img
						className="has-img-bg-body-img"
						width={this.state.wWidth - 15}
						height={this.state.wHeight}
						src="//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/gvmgh39p__w7680_h3920.png"
					/>
					<div className="has-img-bg-body-content  flex-cl">
						<div className="header-top-body flex-row">
							<span style={{ flexGrow: 1 }} className="header-top-span">
								长沙五八小额贷款有限责任公司
							</span>
							<span className="header-top-span">客服热线：4000405858</span>
						</div>
						<div className="header-title-body flex-cl">
							<span className="header-title-span">普惠金融，科技引领</span>
							<span className="header-title-span">
								每一个奋斗者都值得被尊敬
							</span>
						</div>
						<span className="header-note-body header-note-span">
							面向蓝领、新市民及灵活就业者提供全线上化、安全、专业的小额信贷服务
						</span>
					</div>
				</div>
				<div className="content-body flex-cl" style={{ paddingBottom: "5%" }}>
					<span className="content-title-body content-title-font">
						产品优势
					</span>
					<div
						className="content-body-padding flex-row"
						style={{ marginTop: "3%" }}
					>
						<div className="content-prd-adv-card flex-cl">
							<img
								className="content-prd-adv-card-img"
								src="//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/kkesto7c__w720_h720.png"
							/>
							<span
								className="content-prd-adv-card-p"
								style={{ marginTop: "8%", marginBottom: "3%" }}
							>
								精准的
							</span>
							<span className="content-prd-adv-card-p">
								风险模型严格把控资产质量
							</span>
						</div>
						<div className="content-prd-adv-card flex-cl">
							<img
								className="content-prd-adv-card-img"
								src="//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/irv95f7t__w720_h720.png"
							/>
							<span
								className="content-prd-adv-card-p"
								style={{ marginTop: "8%", marginBottom: "3%" }}
							>
								高效的
							</span>
							<span className="content-prd-adv-card-p">
								技术团队搭建领先线上流程
							</span>
						</div>
						<div className="content-prd-adv-card flex-cl">
							<img
								className="content-prd-adv-card-img"
								src="//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/hahc9c59__w720_h720.png"
							/>
							<span
								className="content-prd-adv-card-p"
								style={{ marginTop: "8%", marginBottom: "3%" }}
							>
								差异化的
							</span>
							<span className="content-prd-adv-card-p">
								金融产品满足不同客群需求
							</span>
						</div>
						<div
							className="content-prd-adv-card flex-cl"
							style={{ marginRight: 0 }}
						>
							<img
								className="content-prd-adv-card-img"
								src="//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/n4ee4shq__w720_h720.png"
							/>
							<span
								className="content-prd-adv-card-p"
								style={{ marginTop: "8%", marginBottom: "3%" }}
							>
								正规的
							</span>
							<span className="content-prd-adv-card-p">
								小贷牌照保证合法合规经营
							</span>
						</div>
					</div>
				</div>
				<div className="has-img-bg-body">
					<span
						className="has-img-bg-body-header-presets"
						style={{ height: `${(this.state.height * 1) / 2}px` }}
					/>
					<img
						className="has-img-bg-body-img"
						width={"100%"}
						src="//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/9igjnapl__w7680_h2548.png"
					/>
					<div className="has-img-bg-body-content flex-cl">
						<span className="content-title-body content-title-font">
							关于我们
						</span>
						<div className="flex-cl content-body-left">
							<span className="content-body-about-us-line">
								长沙五八小额贷款有限责任公司于2017年07月20日成立，08月09日正式开业
							</span>
							<span className="content-body-about-us-line">
								公司经营范围包括：通过网络平台面向全国办理自营贷款业务，在长沙市范围内发放小额贷款，提供财务咨询，以及经省政府金融办批准的其他业务等
							</span>
							<span className="content-body-about-us-line">
								58小贷公司设有总经理办公室、风控中心（分别设立贷前、贷中、贷后及征信部）、产品管理部、网络信贷部、技术研发部、财务部、合规监察部、综合管理部等11个部门；拥有注册会计师、法务及信贷行业专业技术人才，并通过广纳贤能，致力于组建高素质、高效率的专业信贷团队
							</span>
						</div>
					</div>
				</div>
				<div className="content-honor-bg content-body flex-cl">
					<span className="content-title-body content-title-font">
						公司荣誉
					</span>
					<div className="flex-row content-body-padding">
						<div className="content-honor-card flex-cl">
							<div className="content-honor-time flex-row">
								<span style={{ flexGrow: 1 }}></span>
								<div className="content-honor-time-body flex-row">
									<span className="content-honor-time-body-span">2024.11</span>
								</div>
								<span className="content-honor-time-line" />
							</div>
							<img
								className="content-honor-img"
								src="//rocketmgr012.58wos.com.cn/iJkFeDcBiJiJ/rocket/zlmRyJwDgZ1789463914723.png"
							/>
						</div>
						<div className="content-honor-card flex-cl">
							<div className="content-honor-time flex-row">
								<span className="content-honor-time-line" />
								<div className="content-honor-time-body flex-row">
									<span className="content-honor-time-body-span">2025.07</span>
								</div>
								<span className="content-honor-time-line" />
							</div>
							<img
								className="content-honor-img"
								src="//rocketmgr012.58wos.com.cn/iJkFeDcBiJiJ/rocket/6PuF22RB11789526522147.png"
							/>
						</div>
						<div className="content-honor-card flex-cl">
							<div className="content-honor-time flex-row">
								<span className="content-honor-time-line" />
								<div className="content-honor-time-body flex-row">
									<span className="content-honor-time-body-span">2026.01</span>
								</div>
								<span style={{ flexGrow: 1 }}></span>
							</div>
							<img
								className="content-honor-img"
								src="//rocketmgr012.58wos.com.cn/iJkFeDcBiJiJ/rocket/3ln0Wmy781789463914722.png"
							/>
						</div>
					</div>
				</div>

				<div
					className="content-honor-bg content-body flex-cl"
					style={{ paddingBottom: "4%" }}
				>
					<span
						className="content-title-body content-title-font"
						style={{ marginBottom: "2%", marginTop: "3%" }}
					>
						营业执照
					</span>
					<div className="flex-row content-body-padding">
						<div className="content-honor-card flex-cl">
							<img
								className="content-honor-img"
								src="//j1.58cdn.com.cn/jinrong/images/ems1715767499756f931b3c35fbea.jpg"
							/>
						</div>
						<div className="content-honor-card flex-cl">
							<img
								className="content-honor-img"
								src="//j1.58cdn.com.cn/jinrong/images/ems1715767498208004bcb564596.jpg"
							/>
						</div>
					</div>
				</div>

				<div className="content-footer flex-cl">
					<div className="content-footer-line flex-row">
						<img
							className="content-footer-line-img"
							src="//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/s70sr4m8__w288_h288.png"
							style={{ marginRight: "1%" }}
						/>
						<span className="content-footer-line-fs-big">400-040-5858</span>
					</div>
					<div
						className="content-footer-line flex-row"
						style={{ marginTop: "4%" }}
					>
						<span
							className="content-footer-line-fs-midlle"
							style={{ marginRight: "1%" }}
						>
							长沙五八小额贷款有限责任公司
						</span>
						<span
							className="content-footer-line-fs-midlle"
							style={{ marginRight: "1%" }}
						>
							公司地址：湖南湘江新区西湖街道枫林一路西湖文化园创意文化街B1-201-1号
						</span>
					</div>
					<div
						className="content-footer-line flex-row"
						style={{ marginTop: "3%" }}
					>
						<span className="content-footer-line-fs-small">
							版权所有 Copyright © {this.state.nTime}{" "}
							长沙五八小额贷款有限责任公司{" "}
							<a
								href="https://beian.miit.gov.cn"
								target="
                    "
							>
								湘ICP备19024067号
							</a>
						</span>
					</div>
				</div>
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./views/pages/index/App.js